export function getURLParameter(name) {
  return (
    decodeURIComponent(
      (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(
        /\+/g,
        '%20'
      )
    ) || null
  )
}

export function is360ViewerDevice() {
  return isMetaQuestBrowser() || isVisionProBrowser() ? 'spatial-component' : ''
}

export function isTouchDevice() {
  return (
    window.matchMedia('(pointer: coarse)').matches ||
    navigator.maxTouchPoints > 0 ||
    'ontouchstart' in window
  )
}

export function isMetaQuestBrowser() {
  const userAgent = navigator.userAgent
  return userAgent.includes('OculusBrowser') && userAgent.includes('Quest')
}

export function isVisionProBrowser() {
  //return true
  if (navigator && navigator.userAgent.includes('Macintosh') && navigator.maxTouchPoints >= 5) {
    return true
  }
  return false
}
